<template>
  <div v-if="visible" @click.self="closeOnClickModal && closeConfirm()" class="confirm-container confirm-mask">
    <div class="confirm-wrapper">
      <div :class="{ noContentText: !content }" class="confirm-header">{{ title }}</div>
      <div v-if="content" class="confirm-content">{{ content }}</div>
      <div :class="{ noCancelButton: !showCancelButton }" class="confirm-btns">
        <div
          v-if="showCancelButton"
          class="confirm-btns__item confirm-btns__cancel"
          size="small"
          round
          inline
          @click="closeConfirm()"
        >
          {{ cancelButtonText }}
        </div>
        <div
          class="confirm-btns__item confirm-btns__submit"
          size="small"
          type="primary"
          round
          inline
          @click="closeConfirm('confirm')"
        >
          {{ confirmButtonText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false, // 是否显示confirm
      title: '', // 标题
      content: '', // 描述内容
      showCancelButton: true, // 是否显示取消按钮
      cancelButtonText: '取消', // 取消按钮文字
      confirmButtonText: '确定', // 确定按钮文字
      closeOnClickModal: false, // 是否可通过点击遮罩关闭
      promiseStatus: null,
    };
  },

  methods: {
    confirm() {
      this.visible = true;
      return new Promise((resove, reject) => {
        this.promiseStatus = { resove, reject };
      });
    },

    /**
     * 关闭弹窗
     * @param { String } 'cancel' | 'confrim'
     */
    closeConfirm(type = 'cancel') {
      this.visible = false;
      if (this.promiseStatus) {
        type === 'confirm' && this.promiseStatus.resove();
        type === 'cancel' && this.promiseStatus.reject();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-container {
  display: flex;
  align-items: center;
  justify-content: center;

  &.confirm-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
  }

  .confirm-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    color: #1d2129;
    font-size: 0.28rem;
    font-weight: 500;
    line-height: 1;
    font-family: 'PingFang SC';
    padding: 0.64rem;
    border-radius: 0.4rem;
    background-color: #fff;
    background-size: 100%, 100%;
  }

  .confirm-header {
    font-size: 0.36rem;
    line-height: 0.5rem;
    font-weight: bold;

    &.noContentText {
      margin-bottom: 0.48rem;
    }
  }

  .confirm-content {
    color: #4e5969;
    line-height: 0.36rem;
    margin: 0.24rem 0 0.4rem;
  }

  .confirm-btns {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &__item {
      height: auto;
      border: none;
      font-size: 0.34rem;
      color: #fff;
      line-height: 1;
      padding: 0.23rem 0.8rem;
      background: #168dff;
      border-radius: 0.4rem;

      & + .confirm-btns__item {
        margin-left: 0.4rem;
      }

      &::after {
        border: none;
      }
    }

    &__cancel {
      background: #ecf6ff;
      color: #168dff;
    }

    &.noCancelButton {
      .confirm-btns__submit {
        padding: 0.23rem 0.86rem;
      }
    }
  }
}
</style>
